import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { FALLBACK_LANG, pickLang, resources, type Lang } from '@78/i18n';
import { getLanguageCode } from './telegram.ts';

const STORAGE_KEY = '78.lang';

/**
 * Язык берём из Telegram, но сохранённый выбор пользователя главнее: язык
 * интерфейса Telegram и язык, на котором человеку удобно читать про деньги,
 * совпадают не всегда.
 */
export function detectLang(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'ru' || saved === 'en') return saved;
  } catch {
    // приватный режим — просто идём дальше
  }
  return pickLang(getLanguageCode());
}

export function setLang(lang: Lang): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // не смогли запомнить — не повод ломать переключение
  }
  void i18next.changeLanguage(lang);
}

export function initI18n(): void {
  void i18next.use(initReactI18next).init({
    resources,
    lng: detectLang(),
    fallbackLng: FALLBACK_LANG,
    interpolation: { escapeValue: false },
  });
}

export { i18next };
